import $http from '@Config/axios';

const prefix = 'sugestao-profissional';

export default {
  upsert(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/upsert`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  show(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/show/${params.evento_id}`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  }
};
